export const setupConstants = {
   REQUEST_SETUP_DATA: 'REQUEST_SETUP_DATA',
   REQUEST_SETUP_DATA_ERROR: 'REQUEST_SETUP_DATA_ERROR',
   REQUEST_SETUP_DATA_SUCCESS: 'REQUEST_SETUP_DATA_SUCCESS',
   SETUP_APP: 'SETUP_APP',
};
